module.exports = __webpack_public_path__ + "static/media/new-orleans.e0d728ae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/new-orleans.jpeg
// module id = 557
// module chunks = 0